import { Flex } from 'antd';
import { Link } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import PublicLayout from '@/layouts/public-layout/public.layout';
import Logo from '@/components/logo/logo';
import { PublicSupport as PublicSupportForm } from '@/components/public-support/public-support';
import styles from './public-support.module.scss';
import { useTranslation } from 'react-i18next';

export function PublicSupportPage() {
  const { t } = useTranslation('support');

  return (
    <PublicLayout>
      <Flex vertical align="center" className={styles.wrapper}>
        <Flex vertical gap={32} align="center" className={styles.container}>
          <Logo />
          <Link to="/sign-in" className={styles.backLink}>
            <ArrowLeftOutlined /> {t('publicPage.backToSignIn')}
          </Link>
          <Flex vertical gap={8} align="center">
            <h2 className={styles.title}>{t('publicPage.title')}</h2>
            <p className={styles.subtitle}>{t('publicPage.subtitle')}</p>
          </Flex>
          <PublicSupportForm />
        </Flex>
      </Flex>
    </PublicLayout>
  );
}
